<template>
	<FlightDetails
		:departure-time="convertDateToTime(flightData?.Departure.Date)"
		:arrival-time="convertDateToTime(flightData?.Arrival.Date)"
		:airline="flightData?.Departure?.Airline?.Name"
		:number-of-stops="numberOfStops"
		:duration="duration"
	/>
</template>

<script setup lang="ts">
import type { OfferItemFlightDataAlternative } from '@/interfaces/offer';
import FlightDetails from './FlightDetails.vue';
import { computed } from 'vue';
import { convertDateToTime } from '@/js/utils/dateTimeUtils';

type Props = {
	flightData: OfferItemFlightDataAlternative | undefined;
	duration?: number;
};

const { flightData } = defineProps<Props>();

const numberOfStops = computed(() => {
	if (!flightData?.DirectFlightAssumed && flightData?.NumberOfStops === 0) return;
	return flightData?.NumberOfStops;
});
</script>
